import { useState } from "react";
import {
  IoCardOutline,
  IoSettingsOutline,
  IoEllipsisHorizontal,
} from "react-icons/io5";

import PaymentConfirmationHeader from "./components/PaymentConfirmationHeader";
import PaymentConfirmationTable from "./components/PaymentConfirmationTable";
import Dropdown from "../../components/common/Dropdown";
import Modal from "../../components/common/Modal";
import PaymentForm from "./components/PaymentForm";
import ConfirmationStatusForm from "./components/ConfirmationStatusForm";

const PaymentConfirmations = () => {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [showStatusForm, setShowStatusForm] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    status: "",
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "created_on", order: "desc" },
  });

  const actions = (item) => {
    return [
      [
        {
          name: "Update Status",
          icon: <IoSettingsOutline className="mr-3 text-gray-400" />,
          action: () => handleStatus(item),
        },
      ],
      [
        {
          name: "Create Payment",
          icon: <IoCardOutline className="mr-3 text-green-500" />,
          action: () => handleCreate(item),
        },
      ],
    ];
  };

  const columns = [
    { path: "name", label: "Name" },
    { path: "reference_number", label: "Reference No." },
    { path: "invoice_amount", label: "Invoice Amount" },
    { path: "amount", label: "Amount" },
    { path: "status_type", label: "Status" },
    { path: "created_on", label: "Date Submitted" },
    {
      key: "actions",
      content: (data) => (
        <Dropdown items={actions(data)} icon={<IoEllipsisHorizontal />} />
      ),
    },
  ];

  const handleStatus = (item) => {
    const result = item ?? null;
    setSelected(result);
    setShowStatusForm(!showStatusForm);
  };

  const handleCreate = (item) => {
    const result = item ?? null;
    setSelected(result);
    setShowCreateForm(!showCreateForm);
  };

  const handleSuccess = (item) => {
    const index = data.findIndex((i) => i.id === item.payment_confirmation_id);

    const items = [...data];
    items[index].status = item.status;
    items[index].status_type = item.status_type;
    setData(items);
  };

  return (
    <div className="px-6 lg:px-0">
      <div className="card p-8 mt-5">
        <PaymentConfirmationHeader
          options={tableOptions}
          onChange={setTableOptions}
        />
        <PaymentConfirmationTable
          data={data}
          columns={columns}
          options={tableOptions}
          onChange={setTableOptions}
          setData={setData}
        />
      </div>
      <Modal
        size="4xl"
        title="Create Payment"
        isOpen={showCreateForm}
        isLoading={isLoading}
        onClose={handleCreate}
        borderTop
      >
        <PaymentForm
          data={selected}
          isLoading={isLoading}
          setLoading={setIsLoading}
          setShow={setShowCreateForm}
          onSuccess={handleSuccess}
        />
      </Modal>
      <Modal
        size="sm"
        title="Update Status"
        isOpen={showStatusForm}
        isLoading={isLoading}
        onClose={handleStatus}
        borderTop
      >
        <ConfirmationStatusForm
          data={selected}
          isLoading={isLoading}
          setLoading={setIsLoading}
          setShow={setShowStatusForm}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default PaymentConfirmations;
